import { render, staticRenderFns } from "./ViewBusinessApprovers.vue?vue&type=template&id=7e2a7232"
import script from "./ViewBusinessApprovers.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBusinessApprovers.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports